export const fileToBase64 = (file: File): Promise<string> => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader()

        reader.onload = () => {
            if (typeof reader.result !== "string") {
                return reject(new Error("FileReader result is not a string"))
            }

            const base64 = reader.result.split(",")[1]

            if (!base64) {
                return reject(new Error("Failed to extract base64 content from data URL"))
            }

            resolve(base64)
        }

        reader.onerror = () => reject(reader.error ?? new Error("Failed to read file"))
        reader.readAsDataURL(file)
    })
}
